import { authRoles } from '../../../auth/authRoles.ts'
import { lazy } from 'react'

const AppMisMetodosDePago = lazy(() => import('./view/MisMetodosPago/MisMetodosPago.tsx'))

export const metodosDePagoRoutesMap = {
  misMetodosPago: {
    path: '/metodos-de-pago/mis-metodos-pago',
    name: 'Métodos de pago',
    action: 'METODOS_DE_PAGO',
  },
}

const metodosDePagoRoutes = [
  {
    path: metodosDePagoRoutesMap.misMetodosPago.path,
    element: <AppMisMetodosDePago />,
    auth: authRoles.admin,
  },
]
export default metodosDePagoRoutes
